var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardSvg1White(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37",
    "data-name": "Rectangle 37",
    width: 22,
    height: 22,
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_3",
    "data-name": "Mask Group 3",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "list",
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    fill: "#fff",
    d: "M20,4H4A1,1,0,0,0,3,5V19a1,1,0,0,0,1,1H20a1,1,0,0,0,1-1V5A1,1,0,0,0,20,4ZM4,2A3,3,0,0,0,1,5V19a3,3,0,0,0,3,3H20a3,3,0,0,0,3-3V5a3,3,0,0,0-3-3ZM6,7H8V9H6Zm5,0a1,1,0,0,0,0,2h6a1,1,0,0,0,0-2ZM8,11H6v2H8Zm2,1a1,1,0,0,1,1-1h6a1,1,0,0,1,0,2H11A1,1,0,0,1,10,12ZM8,15H6v2H8Zm2,1a1,1,0,0,1,1-1h6a1,1,0,0,1,0,2H11A1,1,0,0,1,10,16Z",
    transform: "translate(-1 -2)",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardSvg1White);
export default __webpack_public_path__ + "static/media/card-svg-1-white.c6edacb28e3d2372bb1a1113159aacaf.svg";
export { ForwardRef as ReactComponent };